const trimTrailingSlash = (url: string): string =>
  url &&
  (url.substr(url.length - 1) === '/' ? url.substr(0, url.length - 1) : url);

export { trimTrailingSlash };
